function ensureCallBackOnGTagFailure(callback) {
    var called = false;
    function fn() {
        if (!called) {
            called = true;
            callback();
        }
    }
    setTimeout(fn, 500);
    return fn;
}

function getExtension(href) {
    return href.split("?")[0].split("#")[0].split('.').pop();
}

function openFile(href, ext) {
    if (ext === "pdf") {
        window.open(href, '_blank');
    } else {
        window.location.href = href;
    }
}

$(".ga-event").each(function () {
    var link = $(this);
    this.addEventListener('click', function (event) {
        event.preventDefault();
        var href = link.attr("href");
        var ext = getExtension(href);
        try {
            gtag('event', 'calendar', {
                'event_category': ext,
                'event_label': href,
                'event_callback': openFile(href, ext),
                'event_timeout': 2000
            });
        } catch (ex) {
            console.error(ex);
            openFile(href, ext);
        }
    });
});

$(".ga-template-event").each(function () {
    var link = $(this);
    this.addEventListener('click', function (event) {
        event.preventDefault();
        var href = link.attr("href");
        var ext = getExtension(href);
        try {
            gtag('event', 'template', {
                'event_category': ext,
                'event_label': href,
                'event_callback': openFile(href, ext),
                'event_timeout': 2000
            });
        } catch (ex) {
            console.error(ex);
            openFile(href, ext);
        }
    });
});


